import { Link, NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { clearAdminKey, isAdminAuthenticated } from "./admin-api";
import { PepLogo } from "../components/brand/PepLogo";

export function AdminLayout() {
  const navigate = useNavigate();

  if (!isAdminAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }

  function logout() {
    clearAdminKey();
    navigate("/admin/login", { replace: true });
  }

  return (
    <div className="min-vh-100 bg-body-tertiary">
      <header className="bg-body border-bottom">
        <div className="container py-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
          <Link to="/admin/leads" className="text-decoration-none">
            <PepLogo variant="compact" />
          </Link>
          <nav className="d-flex align-items-center gap-3">
            <NavLink to="/admin/leads" className="text-decoration-none">
              Demandes
            </NavLink>
            <NavLink to="/admin/affiliates" className="text-decoration-none">
              Ambassadeurs
            </NavLink>
            <NavLink to="/admin/affiliation" className="text-decoration-none">
              Affiliation
            </NavLink>
            <NavLink to="/admin/product-content" className="text-decoration-none">
              Vidéos & formations
            </NavLink>
            <NavLink to="/admin/settings" className="text-decoration-none">
              Paramètres
            </NavLink>
            <Link to="/products" className="text-secondary small">
              Site public
            </Link>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={logout}>
              Déconnexion
            </button>
          </nav>
        </div>
      </header>
      <main className="container py-4">
        <Outlet />
      </main>
    </div>
  );
}
